// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__LjO2v","unreadBadge":"styles_unreadBadge__1-D68","modalContent":"styles_modalContent__1axvQ","modal":"styles_modal__2tGHG"};